// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__R6u8t","inner":"Footer_inner__1ZTSl"};